import React from "react";

import { checkoutUpsellTileGraphConfig } from "@intelligems/ig-graphs";
import { AnalyzeTinybirdResourceResponseBodyType } from "@intelligems/ig-types";
import { UpsellAnalyticsPage } from "@src/features/analytics/pages/UpsellAnalyticsPage";
import { UseQueryResult } from "@tanstack/react-query";

interface CheckoutUpsellAnalyticsPageProps {
  data: UseQueryResult<AnalyzeTinybirdResourceResponseBodyType>[];
  totalExperienceVisitors: number;
  testDuration: number;
  compareVariationId: string;
}

export const CheckoutUpsellAnalyticsPage = (
  props: CheckoutUpsellAnalyticsPageProps
) => (
  <UpsellAnalyticsPage
    {...props}
    tileConfig={checkoutUpsellTileGraphConfig}
    productsSource={"checkout_upsell"}
    metricsSectionTitle={"Checkout Upsell Metrics"}
    productsEmptyMessage={"No checkout upsell offers have been accepted yet."}
  />
);
